import { useEffect } from "react";

function labelTableCells() {
  const tables = document.querySelectorAll<HTMLTableElement>("table.MuiTable-root");

  tables.forEach((table) => {
    const headerCells = Array.from(table.querySelectorAll<HTMLTableCellElement>("thead tr:last-child th"));
    const labels = headerCells.map((cell) => cell.textContent?.trim() ?? "");

    table.querySelectorAll<HTMLTableRowElement>("tbody tr").forEach((row) => {
      let columnIndex = 0;

      Array.from(row.children).forEach((cell) => {
        if (!(cell instanceof HTMLElement)) return;

        const colSpan = Number(cell.getAttribute("colspan") ?? 1);
        cell.dataset.mobileLabel = labels[columnIndex] ?? "";
        columnIndex += Number.isFinite(colSpan) && colSpan > 0 ? colSpan : 1;
      });
    });
  });
}

export function useResponsiveTableLabels() {
  useEffect(() => {
    let frame: number | null = null;

    const scheduleLabeling = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        labelTableCells();
      });
    };

    scheduleLabeling();

    const observer = new MutationObserver(scheduleLabeling);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.addEventListener("resize", scheduleLabeling);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", scheduleLabeling);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, []);
}
